import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

const ClasseCard = ({ classe }) => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h5" component="div">
          Classe {classe.numero}
        </Typography>
        <Typography color="text.secondary">
          Descrição: {classe.descricao || 'Não disponível'}
        </Typography>
        <Typography color="text.secondary">
          Campanha: {classe.campanha?.nome || 'Não associada'}
        </Typography>
        <Button 
          component={Link} 
          to={`/classes/${classe.id}`} 
          variant="contained" 
          color="primary" 
          sx={{ mt: 2 }}
        >
          Ver Detalhes
        </Button>
      </CardContent>
    </Card>
  );
};

ClasseCard.propTypes = {
  classe: PropTypes.shape({
    numero: PropTypes.number.isRequired,
    descricao: PropTypes.string,
    campanha: PropTypes.shape({
      nome: PropTypes.string,
    }),
    id: PropTypes.number.isRequired,
  }).isRequired,
};

export default ClasseCard;
